export default "https://assets.stage.yurplan.com/yurplan-v1/dist/msg-box__icon--error.90365ec6a3d7a5d51c237bcf6fe0ca53.svg";